var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedTextfieldMandatoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6867 3.34423C16.5467 3.58423 16.24 3.6709 16 3.5309C15.76 3.39756 15.68 3.0909 15.8133 2.8509L16.1333 2.29756H15.5C15.2267 2.29756 15 2.0709 15 1.79756C15 1.52423 15.2267 1.29756 15.5 1.29756H16.1333L15.82 0.750898C15.68 0.510898 15.76 0.204231 16 0.0642311C16.24 -0.0691022 16.5467 0.0108979 16.6867 0.250898L17 0.797565L17.3133 0.250898C17.4533 0.0108979 17.76 -0.0691022 18 0.0642311C18.24 0.204231 18.32 0.510898 18.18 0.750898L17.8667 1.29756H18.5C18.7733 1.29756 19 1.52423 19 1.79756C19 2.0709 18.7733 2.29756 18.5 2.29756H17.8667L18.1933 2.85756C18.3267 3.09756 18.2467 3.39756 18.0067 3.53756C17.7667 3.6709 17.46 3.5909 17.32 3.3509L17 2.79756L16.6867 3.34423Z",
    fill: "#9C9C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6C0.67 6 0 5.33 0 4.5C0 3.67 0.67 3 1.5 3H11.5C12.33 3 13 3.67 13 4.5C13 5.33 12.33 6 11.5 6H8V16.5C8 17.33 7.33 18 6.5 18C5.67 18 5 17.33 5 16.5V6H1.5Z",
    fill: "#9C9C9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8H17.5C18.33 8 19 8.67 19 9.5C19 10.33 18.33 11 17.5 11H16V16.5C16 17.33 15.33 18 14.5 18C13.67 18 13 17.33 13 16.5V11H11.5C10.67 11 10 10.33 10 9.5C10 8.67 10.67 8 11.5 8Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedTextfieldMandatoryIcon);
export default __webpack_public_path__ + "static/media/DeprecatedTextfieldMandatoryIcon.3d0e1deaf6c8df14a1871b348295db27.svg";
export { ForwardRef as ReactComponent };